namespace nscs.screen {

    export class BaseScreen extends Phaser.GameObjects.Container {

        constructor(scene:Phaser.Scene) {
            super(scene);

            if (!(this instanceof GameScreen)) this.setScrollFactor(0);
        }

        protected createBlackShape():Phaser.GameObjects.Graphics {
            return this.createShape('0x000000');
        }

        protected createShape(color):Phaser.GameObjects.Graphics {
            let transition = new Phaser.GameObjects.Graphics(this.scene);
            transition.setPosition(0, 0);
            transition.fillStyle(color, 1);
            transition.fillRect(0, 0, game.scale.width, game.scale.height);
            transition.setInteractive();

            transition.setScrollFactor(0);

            return transition;
        }

        public switchScreen(newScreen:BaseScreen, useTransition:boolean, destroyOld:boolean, onMidCallback):void {
            let f = ()=>{
                // if (!destroyOld) {
                    if (this instanceof GameScreen) {
                        (this as GameScreen).onRemovedFromParent();
                    }
                // }
                if (newScreen instanceof GameScreen) {
                    (newScreen as GameScreen).onAddedToParent();
                }
            };

            let parentContainer = this.parentContainer;
            if (useTransition) {
                if (destroyOld) {
                    this.scene.tweens.killAll();
                    nscs.util.Functions.destroyAllDelayedCalls();
                    // this.scene.time.removeAllEvents();
                }

                let transition = this.createBlackShape();

                this.parentContainer.add(transition);

                transition.alpha = 0;
                this.scene.tweens.add({
                    targets: transition,
                    alpha: 1,
                    duration: 500,
                    ease: Phaser.Math.Easing.Linear,
                    onComplete: ()=>{
                        this.scene.tweens.add({
                            targets: transition,
                            alpha: 0,
                            duration: 500,
                            ease: Phaser.Math.Easing.Linear,
                            onComplete: ()=>{
                                parentContainer.remove(transition, true);
                            }
                        });

                        f();

                        parentContainer.remove(this, destroyOld);
                        parentContainer.addAt(newScreen, parentContainer.getIndex(transition));

                        if (onMidCallback) onMidCallback();
                    }
                });
            } else {
                f();

                parentContainer.remove(this, destroyOld);
                parentContainer.add(newScreen);

                if (onMidCallback) onMidCallback();
            }
        }

        public updateScreen():void {

        }
    }
}
